/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Decline_Reason_RequiredInputs */

const en_api_error_task_decline_reason_required = /** @type {(inputs: Api_Error_Task_Decline_Reason_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a reason to decline the liability analysis.`)
};

const pt_br2_api_error_task_decline_reason_required = /** @type {(inputs: Api_Error_Task_Decline_Reason_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um motivo para declinar a análise de culpabilidade.`)
};

/**
* | output |
* | --- |
* | "Select a reason to decline the liability analysis." |
*
* @param {Api_Error_Task_Decline_Reason_RequiredInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_decline_reason_required = /** @type {((inputs?: Api_Error_Task_Decline_Reason_RequiredInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Decline_Reason_RequiredInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_decline_reason_required(inputs)
	return pt_br2_api_error_task_decline_reason_required(inputs)
});